import React from "react";
import {
  Select,
  TextInput,
  Text,
  Collapse,
  Button,
  Alert,
} from "@mantine/core";
import {
  IconAlertTriangle,
  IconCaretDownFilled,
  IconCaretUpFilled,
} from "@tabler/icons-react";

interface AdvancedSettingsProps {
  advancedSettingsOpened: boolean;
  setAdvancedSettingsOpened: (opened: boolean) => void;
  possibleChannels: { scid: string; alias: string; local_balance: number }[];
  outgoingChannelScid: string | null;
  handleOutgoingChannelChange: (value: string | null) => void;
  maxFee: string | null;
  handleMaxFeeChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  maxFeeError: string | null;
  pathFindingTimeout: string | null;
  handlePathFindingTimeoutChange: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
  pathFindingTimeoutError: string | null;
}

const AdvancedSettings: React.FC<AdvancedSettingsProps> = ({
  advancedSettingsOpened,
  setAdvancedSettingsOpened,
  possibleChannels,
  outgoingChannelScid,
  handleOutgoingChannelChange,
  maxFee,
  handleMaxFeeChange,
  maxFeeError,
  pathFindingTimeout,
  handlePathFindingTimeoutChange,
  pathFindingTimeoutError,
}) => {
  return (
    <>
      <Button
        onClick={() => setAdvancedSettingsOpened(!advancedSettingsOpened)}
        variant="default"
        size="xs"
        // rightSection={
        //   advancedSettingsOpened ? (
        //     <IconCaretUpFilled />
        //   ) : (
        //     <IconCaretDownFilled />
        //   )
        // }
      >
        {advancedSettingsOpened
          ? "Hide Advanced Settings"
          : "Advanced Payment Settings"}
      </Button>

      <Collapse in={advancedSettingsOpened}>
        {possibleChannels.length > 1 && (
          <Select
            label="Outgoing Channel"
            placeholder="Select an outgoing channel"
            data={[
              { value: "", label: "Any Channel" }, // Option to unset the outgoing channel
              ...possibleChannels.map((channel) => ({
                value: channel.scid,
                label: `${channel.alias} - ${channel.local_balance} satoshis - ${channel.scid}`,
              })),
            ]}
            value={outgoingChannelScid || ""}
            onChange={(value) =>
              handleOutgoingChannelChange(value === "" ? null : value)
            }
          />
        )}
        <TextInput
          type="number" // Add this line
          label="Max Fee (satoshis)"
          placeholder="Enter max fee"
          value={maxFee || ""}
          onChange={handleMaxFeeChange}
          error={maxFeeError}
          mt="md"
        />
        <TextInput
          type="number" // Add this line
          label="Timeout (seconds)"
          placeholder="Enter timeout in seconds"
          value={pathFindingTimeout || ""}
          onChange={handlePathFindingTimeoutChange}
          error={pathFindingTimeoutError}
          mt="md"
        />
        <Alert mt="20px" icon={<IconAlertTriangle size={36} />}>
          <Text size="sm">
            Use with caution: There are many combinations of these advanced
            settings that will result in "route not found" payment failure.
          </Text>
        </Alert>
      </Collapse>
    </>
  );
};

export default AdvancedSettings;
